<template>
  <b-container class="pt-4" fluid="sm">
    <div class="my-encode">
      <div class="mb-3">
        <h3>Generate Ethereum wallet with ethers.js</h3>
        <b-input-group prepend="Quantity:" class="my-3">
          <b-form-input
            type="number"
            v-model="quantity"
            placeholder="Quantity"
          ></b-form-input>
          <b-input-group-append>
            <b-button variant="info" class="px-3" @click="createWallet"
              >Generate</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </div>
    </div>
  </b-container>
</template>
<script>
import { ethers } from "ethers";
import exportFromJson from "export-from-json";
export default {
  name: "ReferralPage",
  data: () => ({
    quantity: 0,
    isPress: true,
  }),
  methods: {
    async createWallet() {
      if (!this.isPress) return;
      this.isPress = false;
      const list = [];
      for (let index = 0; index < this.quantity; index++) {
        const wallet = ethers.Wallet.createRandom();
        list.push({
          adddress: wallet.address,
          privateKey: wallet.privateKey,
          phrase: wallet.mnemonic.phrase,
        });
      }
      this.isPress = true;
      exportFromJson({
        data: list,
        fileName: "wallet-data",
        exportType: "csv",
      });
    },
  },
};
</script>

<style lang="scss">
.my-encode {
  color: #fff;
  background-color: transparent;
  .card-header {
    background-image: linear-gradient(to top, #503161, rgba(70, 50, 100, 0)),
      linear-gradient(to bottom, #eb345f, #eb345f);
    justify-content: center;
  }
  .t-table {
    color: #fff;
    background-color: transparent;
    .title {
      background: linear-gradient(90deg, #472f6b 0%, rgba(71, 47, 107, 0) 100%);
      font-size: 30px;
      font-style: normal;
      font-weight: 600;
      line-height: 37px;
      padding: 6px 0 6px 58px;
      margin-bottom: 12px;
    }
    .t-header {
      color: white;
    }
    .t-tr-row {
      color: white;
    }
    .t-link {
      color: white;
    }
    .no-item {
      text-align: center;
      width: 100%;
      display: block;
      color: #8d3260;
      margin-top: 30px;
      margin-bottom: 60px;
      img {
        max-width: 80px;
      }
    }
  }

  .btn-create {
    padding: 8px 16px;
    border: none;
    font-weight: 700;
    color: #fff;
    background-image: linear-gradient(to top, #503161, rgba(70, 50, 100, 0)),
      linear-gradient(to bottom, #eb345f, #eb345f);
    border-bottom: 2px solid #eb345f;
    font-weight: 700;
    text-transform: uppercase;
    position: relative;
    clip-path: polygon(0 100%, 0 34%, 8% 0%, 100% 0, 100% 100%);
    &:focus,
    &:active {
      box-shadow: none;
    }
  }
  .btn-apply {
    border: none;
    font-weight: 700;
    color: #fff;
    background-image: linear-gradient(to top, #503161, rgba(70, 50, 100, 0)),
      linear-gradient(to bottom, #eb345f, #eb345f);
    border-bottom: 2px solid #eb345f;
    font-weight: 700;
    text-transform: uppercase;
    position: relative;
    clip-path: polygon(0 100%, 0 34%, 0% 0%, 100% 0, 100% 100%);
    &:focus,
    &:active {
      box-shadow: none;
    }
  }
}
</style>
